import { render, staticRenderFns } from "./OrsNotifications.vue?vue&type=template&id=50212b5a&scoped=true&"
import script from "./OrsNotifications.vue?vue&type=script&lang=js&"
export * from "./OrsNotifications.vue?vue&type=script&lang=js&"
import style0 from "./OrsNotifications.vue?vue&type=style&index=0&id=50212b5a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50212b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/workspace/orse-infra-novo-portal-frontend-ecs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VSnackbar})
